import _ from 'lodash';
import React from 'react';

import Button from 'components/Button';

import SelectFilter from 'components/Filters/SelectFilter';
import DateRangeFilter from 'components/Filters/DateRangeFilter';
import TreeSelect from 'components/Filters/TreeSelect';

import {
  getBookingSetStatusGroups,
  getBookingSetStatusesForStatusGroup
} from 'ducks/bookingSets';

import './styles.css';

const bookingSetStatusFilters = getBookingSetStatusGroups().map(value => ({
  label: value,
  data: getBookingSetStatusesForStatusGroup(value).map(status => ({
    label: status,
    key: status
  }))
}));

interface PassedProps {
  setFilter: (field: string, value: any) => void;
  clearFilters: () => void;
  getFilters: any;
  rooms: any;
}

class MemberListFilters extends React.Component<PassedProps> {
  clearFilters = () => {
    this.props.clearFilters();
  };

  render() {
    const {setFilter, rooms} = this.props;
    const filters: any = this.props.getFilters();

    const roomsData = rooms.map(room => ({
      label: room.roomNumber,
      value: room.id
    }));

    return (
      <div className="MemberListFilters colab-row-space-between">
        <div className="colab-sidepadding-2">
          <SelectFilter
            label="Room Number"
            classNameForTesting="roomNumber"
            data={roomsData}
            value={filters.rooms}
            onChange={rooms => setFilter('rooms', rooms)}
          />
          <DateRangeFilter
            label="Arrival"
            fieldName="arrival"
            classNameForTesting="arrival"
            start={filters.arrivalAfter}
            end={filters.arrivalBefore}
            startFieldName="arrivalAfter"
            endFieldName="arrivalBefore"
            onChange={(dateField, date) => setFilter(dateField, date)}
          />
          <DateRangeFilter
            label="Departure"
            fieldName="departure"
            classNameForTesting="departure"
            start={filters.departureAfter}
            end={filters.departureBefore}
            startFieldName="departureAfter"
            endFieldName="departureBefore"
            onChange={(dateField, date) => setFilter(dateField, date)}
          />
          <TreeSelect
            label="Booking Set Status"
            classNameForTesting="bookingSetStatus"
            data={bookingSetStatusFilters}
            value={filters.bookingSetStatuses}
            onFilterChange={bookingSetStatuses =>
              setFilter('bookingSetStatuses', bookingSetStatuses)
            }
          />
        </div>
        <div>
          <Button clear onClick={this.clearFilters}>
            Clear all filters
          </Button>
        </div>
      </div>
    );
  }
}

export default MemberListFilters;
